module.exports = __webpack_public_path__ + "img/new-lpbanner-2.f22d0a01.jpg";